import { Dispatch, SetStateAction } from 'react'

import { IQuestion } from '@ucheba/store/questions/types'
import { IFeedback } from '@ucheba/store/feedbacks/types'
import { IInstitutionQuestion } from '@ucheba/store/institutions/questions/types'
import { TExtraParams } from '../../pages/uz/ssr/[id]/utils/useBannerProgramTypes/types'

export type TListItem = Omit<IInstitutionQuestion, 'responses'>

export type TReducedDataList = Array<{
  root: TListItem
  responses: TListItem[]
}>

export interface IItemProps {
  isResponse?: boolean
  isDivider?: boolean
  limit?: number
  offset?: number
  id: number
  rate: number | undefined
  date: string
  faculty: {
    id: number
    name: string
  } | null
  text: string
  program: {
    id: number
    name: string
  } | null
  type: FormType
  owner: IInstitutionQuestion['owner']
  responseFor: IInstitutionQuestion['responseFor']
  voteStats: IInstitutionQuestion['voteStats']
  onAnswerClick: () => void
  itemsLength: number
  rootId: number
  rootType: 'institution' | 'program'
}

export type FormType =
  | 'questions'
  | 'responsesQuestions'
  | 'feedbacks'
  | 'responsesFeedbacks'

export enum EFormType {
  questions = 'questions',
  responsesQuestions = 'responsesQuestions',
  responsesFeedbacks = 'responsesFeedbacks',
  feedbacks = 'feedbacks',
}

export interface ICommunicationFormProps {
  type: 'institution' | 'program'
  formType: EFormType
  isOpen: boolean
  parentId: number | null
  onClose: () => void
  scrollTo?: () => void
  list: IQuestion[] | IFeedback[]
  rootId: number
  limit?: number
  offset?: number
  onAfterSubmit?: () => void
}

export interface IUsersCommunicationProps {
  isBanner?: boolean
  institutionRate?: number | null | undefined
  params: TExtraParams
  total: number
  rootId: number
  rootType: 'institution' | 'program'
  type: FormType
  items: IQuestion[]
  limit?: number
  offset?: number
  onAfterSubmit?: () => void
}

export interface IResponsesListProps {
  parentId: string
  limit?: number
  offset?: number
  responses: TListItem[]
  type: FormType
  onAnswerClick: (id: number) => void
  itemsLength: number
  rootId: number
  rootType: 'institution' | 'program'
}

export type TUseResponsesList = (
  responses: TListItem[],
  parentId: string
) => {
  responsesList: TListItem[]
  showAllAnswers: boolean
  setShowAllAnswers: Dispatch<SetStateAction<boolean>>
  representativeInstitution: string
}

export interface IControlsProps {
  id: number
  type: FormType
  voteStats: IInstitutionQuestion['voteStats']
  onAnswerClick: () => void
  listLength: number
  rootId: number
  rootType: 'institution' | 'program'
  limit?: number
  offset?: number
}

export interface IFeedbackHeader {
  showHint?: boolean
  sendingLoading: boolean
  rate: number
  setRate: (rate: number) => void
}

export type IUseCommunicationForm = (
  type: FormType,
  list: IQuestion[] | IFeedback[],
  reqType: 'institution' | 'program',
  callback?: () => void,
  limit?: number,
  offset?: number,
  onAfterSubmit?: () => void
) => {
  error: string | null
  setError: Dispatch<SetStateAction<string | null>>
  onSubmit: (
    text: string,
    isPublished: boolean,
    parentId: number | null,
    rate: number,
    id: number
  ) => Promise<any>
}
